import { Dictionary } from '@feedyou/utils'
import {
  AdditionalValidationParams,
  formatValidators,
  ValidatorCriteria
} from '../../../lib/rjsf-validation/validationSchema'
import { evaluateCriteria } from '../../../lib/rjsf-validation/utils'

export const createCustomFormats = (
  params: AdditionalValidationParams
): Dictionary<string, ValidatorCriteria> => {
  const customFormats: Dictionary<string, ValidatorCriteria> = {}

  for (const [formatName, { criteria }] of Object.entries(formatValidators)) {
    if (criteria !== undefined) {
      customFormats[formatName] = (text: string) => evaluateCriteria(criteria, text, params)
    }
  }

  return customFormats
}
